
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { type SocialLink } from "@/types/profile";

interface SocialLinksProps {
  socialLinks: SocialLink[];
  onSocialLinksChange: (socialLinks: SocialLink[]) => void;
}

export const SocialLinks = ({ socialLinks, onSocialLinksChange }: SocialLinksProps) => {
  const handleSocialLinkChange = (index: number, field: 'platform' | 'url', value: string) => {
    const updatedLinks = socialLinks.map((link, i) =>
      i === index ? { ...link, [field]: value } : link
    );
    onSocialLinksChange(updatedLinks);
  };

  const addSocialLink = () => {
    onSocialLinksChange([...socialLinks, { platform: '', url: '' }]);
  };

  const removeSocialLink = (index: number) => {
    onSocialLinksChange(socialLinks.filter((_, i) => i !== index));
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <Label>Social Links</Label>
        <Button
          type="button"
          variant="outline"
          onClick={addSocialLink}
        >
          Add Link
        </Button>
      </div>
      
      <div className="space-y-4">
        {socialLinks.map((link, index) => (
          <div key={index} className="flex gap-2">
            <Input
              placeholder="Platform"
              value={link.platform}
              onChange={(e) => handleSocialLinkChange(index, 'platform', e.target.value)}
            />
            <Input
              placeholder="URL"
              value={link.url}
              onChange={(e) => handleSocialLinkChange(index, 'url', e.target.value)}
            />
            <Button
              type="button"
              variant="destructive"
              onClick={() => removeSocialLink(index)}
            >
              Remove
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};
